import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=041eb211&scoped=true&"
import script from "./UserNotifications.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserNotifications.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=041eb211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041eb211",
  null
  
)

export default component.exports